// Carry Roll Club presets — loft presets & category behavior (6.1, 6.2).
import { ClubCategory } from '../engine/types';
export const CLUB_PRESETS = [
    { name: 'Driver', category: ClubCategory.Driver, loftDeg: 10.5, rollPercent: 0.2 },
    { name: '3-Wood', category: ClubCategory.Wood, loftDeg: 15, rollPercent: 0.16 },
    { name: '5-Wood', category: ClubCategory.Wood, loftDeg: 18, rollPercent: 0.14 },
    { name: '3-Hybrid', category: ClubCategory.Hybrid, loftDeg: 21, rollPercent: 0.12 },
    { name: '4-Iron', category: ClubCategory.Iron, loftDeg: 24, rollPercent: 0.1 },
    { name: '5-Iron', category: ClubCategory.Iron, loftDeg: 27, rollPercent: 0.09 },
    { name: '6-Iron', category: ClubCategory.Iron, loftDeg: 31, rollPercent: 0.08 },
    { name: '7-Iron', category: ClubCategory.Iron, loftDeg: 35, rollPercent: 0.07 },
    { name: '8-Iron', category: ClubCategory.Iron, loftDeg: 39, rollPercent: 0.06 },
    { name: '9-Iron', category: ClubCategory.Iron, loftDeg: 43, rollPercent: 0.05 },
    { name: 'PW', category: ClubCategory.Wedge, loftDeg: 47, rollPercent: 0.04 },
    { name: 'GW', category: ClubCategory.Wedge, loftDeg: 52, rollPercent: 0.03 },
    { name: 'SW', category: ClubCategory.Wedge, loftDeg: 56, rollPercent: 0.02 },
    { name: 'LW', category: ClubCategory.Wedge, loftDeg: 60, rollPercent: 0.01 },
];
export const ROLL_PERCENT_BY_CATEGORY = {
    [ClubCategory.Driver]: 0.2,
    [ClubCategory.Wood]: 0.15,
    [ClubCategory.Hybrid]: 0.12,
    [ClubCategory.Iron]: 0.08,
    [ClubCategory.Wedge]: 0.03,
};
//# sourceMappingURL=clubPresets.js.map